import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import App from "./App";
import store from "./store";
import { injectStore } from "./services/api";
import { startSessionKeeper } from "./utils/sessionKeeper";
import { ThemeModeProvider } from "./components/ThemeMode";

injectStore(store);
startSessionKeeper(store);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<ThemeModeProvider>
					<SnackbarProvider
						maxSnack={3}
						anchorOrigin={{
							vertical: "top",
							horizontal: "right",
						}}
						autoHideDuration={3000}
					>
						<App />
					</SnackbarProvider>
				</ThemeModeProvider>
			</BrowserRouter>
		</Provider>
	</React.StrictMode>,
);
